import { DEFAULT_MINOR_UNITS } from "@/data/currencyUnits";
import { resolveMinorUnits } from "./resolveMinorUnits";

// The inverse of `toMajorUnits`, for the APIs that answer in major units (V1
// estimate) while the rest of the app works in minor units.
export const toMinorUnits = (amount: number, currency?: string): number =>
  amount * (resolveMinorUnits(currency) ?? DEFAULT_MINOR_UNITS);
